import { ca } from '@cian/analytics';
import {
  ICreateCianAnalyticsPageViewObjectParams,
  createCianAnalyticsPageViewObject,
} from './createCianAnalyticsPageViewObject';

export const trackPageView = (params: ICreateCianAnalyticsPageViewObjectParams) => {
  ca('pageviewSite', createCianAnalyticsPageViewObject(params));
};
